module.exports = __webpack_public_path__ + "img/Bear04.17a17bed.jpg";